const paletteByTheme = {
  blue: {
    "30": "#3673F7",
    "40": "#0C4DED",
    "50": "#003BDE",
    "55": "#0035D4",
    "60": "#002FCA",
    "70": "#0024B0"
  },
  sky: {
    "30": "#2BB1E8",
    "40": "#00A0DC",
    "50": "#0092D1",
    "55": "#0089C9",
    "60": "#0081C2",
    "70": "#006EAF"
  },
  teal: {
    "30": "#53E2CC",
    "40": "#31D1BB",
    "50": "#15BCA8",
    "55": "#0aae9c",
    "60": "#00A091",
    "70": "#18867D"
  },
  red: {
    "30": "#F2575D",
    "40": "#E7323B",
    "50": "#D51A2C",
    "55": "#C91329",
    "60": "#BD0B25",
    "70": "#9F0223"
  },
  orange: {
    "30": "#FFB062",
    "40": "#FF8B33",
    "50": "#E56000",
    "55": "#D14900",
    "60": "#BB4107",
    "70": "#A93F0C"
  },
  purple: {
    "30": "#A589FA",
    "40": "#856DF0",
    "50": "#6C51DC",
    "55": "#6046CF",
    "60": "#553CC2",
    "70": "#402BA3"
  },
  green: {
    "30": "#74D56D",
    "40": "#54C247",
    "50": "#459D3A",
    "55": "#338E3C",
    "60": "#2C8147",
    "70": "#287753"
  },
  cyan: {
    "30": "#42D6E0",
    "40": "#20BBC5",
    "50": "#1898A4",
    "55": "#058899",
    "60": "#04798B",
    "70": "#01697E"
  }
};

export default paletteByTheme;
